import { type PercentCrop } from "react-image-crop";

const PERCENT_SCALE = 100;

export const imageCropping = {
  crop: (
    image: HTMLImageElement,
    crop: PercentCrop,
    fileName: string,
  ): Promise<File> => {
    const canvas = document.createElement("canvas");
    const sourceX = (crop.x / PERCENT_SCALE) * image.naturalWidth;
    const sourceY = (crop.y / PERCENT_SCALE) * image.naturalHeight;
    const width = Math.round((crop.width / PERCENT_SCALE) * image.naturalWidth);
    const height = Math.round(
      (crop.height / PERCENT_SCALE) * image.naturalHeight,
    );
    if (!width || !height)
      return Promise.reject(new Error("Select a larger crop"));
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context)
      return Promise.reject(new Error("Could not prepare the image"));
    context.drawImage(
      image,
      sourceX,
      sourceY,
      width,
      height,
      0,
      0,
      width,
      height,
    );
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Could not crop the image"));
          return;
        }
        resolve(
          new File([blob], `${fileName.replace(/\.[^.]+$/, "")}.png`, {
            type: "image/png",
          }),
        );
      }, "image/png");
    });
  },
};
